<template>
  <div class="home">
    <div class="flex-grid">
      <div class="grid-title">
        <h1>Nueva Orden de Entrega {{ $t(`offer.${this.offer.subtype}`)}}</h1>
      </div>
      
     <DeliveryCreateForm :offer-type="'sell'"/>
    </div>
  </div>
</template>

<script>

//import OfferCreateForm from '@/components/OfferCreateForm.vue'
import DeliveryCreateForm from '../components/DeliveryCreateForm.vue'
import { mapState } from 'vuex'
import axios from 'axios'
import OfferCreateForm from '../components/OfferCreateForm.vue'

axios.defaults.headers.common['referer-id'] = new Date().toLocaleString().replace(/[^\d]/g, '') + parseInt(Math.random() * 100000)

export default {
  name: 'createSellerDlivey',
  components: {
    DeliveryCreateForm,
    OfferCreateForm
},
  computed: mapState({
    offer: state => state.Offer.offer
  })
}
</script>
